import {Request, Map} from '@/services/http/request';

const request = new Request(process.env.VUE_APP_BACKEND_PORTAL);

export default class Index {
    static create(data: Map, uri: string) {
        return request.post(uri, data);
    }
}